/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const CheckCircle = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M18 10c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8zm-8.9 4.2L15 8.3c.2-.2.2-.5 0-.7l-.7-.7c-.2-.2-.5-.2-.7 0l-4.8 4.8-2.4-2.3c-.2-.2-.5-.2-.7 0l-.7.8c-.2.2-.2.5 0 .7l3.4 3.4c.1.1.5.1.7-.1z" />
  </svg>
);

export default extendIcon(CheckCircle);
